(function () {
    'use strict';

    function searchFieldConfigurationsDataService($http) {
        var baseUrl = '[BuildifyApiHost]/api/searchfieldconfigurations/';

        function loadSearchFieldConfigurations(entityType) {
            return $http.get(baseUrl + entityType).then(function (response) {
                return response.data;
            });
        };

        function loadSearchFieldConfigurationsForSite(siteName) {
            return $http.get(baseUrl + 'site/' + siteName).then(function (response) {
                return response.data;
            });
        };

        return {
            loadSearchFieldConfigurations: loadSearchFieldConfigurations,
            loadSearchFieldConfigurationsForSite: loadSearchFieldConfigurationsForSite
        }
    }

    searchFieldConfigurationsDataService.$inject = ['$http'];

    angular.module('ecap.common').service('searchFieldConfigurationsDataService', searchFieldConfigurationsDataService);
})();
